import { render, staticRenderFns } from "./projet.vue?vue&type=template&id=2f7f32a3&"
import script from "./projet.vue?vue&type=script&lang=js&"
export * from "./projet.vue?vue&type=script&lang=js&"
import style0 from "./projet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports